import styled from 'styled-components';
import { getThemeColor, getThemeTypography } from 'utils/styled';

export const Root = styled.div`
  ${getThemeTypography('h2')};
  background-color: ${getThemeColor('danger')};
  border-radius: 10px;
  color: ${getThemeColor('white')};
  padding: 9.5px 10px;
  text-align: center;
  width: 100%;
`;
